import React from 'react';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import style from './CampaignStatus.module.scss';
const Active = () => {
    return (React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.positive, className: style.status }, "Active"));
};
export default Active;
